import { z } from 'zod'

export const discounTypeSchema = z.enum([
  'invisible',
  'crossed',
  'message',
  'countdown',
])
